import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';

import { map, Observable } from 'rxjs';

import { Config } from '../configs/config';

import { HttpService } from './http-service';
import { LocalStorageService } from './local-storage.service';

import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AiAssistantService {
  private _startDate = null;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private httpService: HttpService,
    private localStorageService: LocalStorageService,
  ) {}

  get startDate(): Date | null {
    return this._startDate;
  }

  sendMessage(inputText: string, preferences: string[] = []): Observable<any> {
    const sessionId =
      this.localStorageService.getLocalStorage('api-session-id');
    let params = new HttpParams()
      .set('question', inputText)
      .set('chatId', sessionId);

    if (preferences.length) {
      params = params.append('preferences', preferences.join(','));
    }

    return this.http.get(Config.apiUrl + 'api/trip-planner/ai', {
      params: params,
    });
  }

  getChatHistory(): Observable<any> {
    const sessionId =
      this.localStorageService.getLocalStorage('api-session-id');
    const params = new HttpParams().set('chatId', sessionId);

    return this.http.get(Config.apiUrl + 'api/trip-planner/ai/history', {
      params: params,
    });
  }

  clearChatHistory(): Observable<any> {
    const sessionId =
      this.localStorageService.getLocalStorage('api-session-id');
    const params = new HttpParams().set('chatId', sessionId);

    return this.http.get(Config.apiUrl + 'api/trip-planner/ai/history/clear', {
      params: params,
    });
  }

  createAiRoute(cities: any[], aiAssistant: any): Observable<any> {
    const routes = cities.filter((city) => city.country_id);
    const firstLocation = routes[0];
    const lastLocation = routes[routes.length - 1];
    let tripRoute = '';
    routes.forEach((route, index) => {
      let days = 0;

      if (route && route.days_in_city >= 0) {
        days = route.days_in_city;
      }

      if (routes.length - 1 === index) {
        tripRoute += `${route.place_id}:${days}`;
        return;
      }

      tripRoute += `${route.place_id}:${days},`;
    });

    let startDate = '';
    if (this.startDate) {
      startDate = this.datePipe.transform(
        moment(this.startDate).toDate(),
        'mediumDate',
      );
    }

    const params =
      '?start[id]=' +
      firstLocation.place_id +
      '&start[name]=' +
      encodeURIComponent(firstLocation.name) +
      '&start[days]=' +
      (!firstLocation.days_in_city ? 0 : firstLocation.days_in_city) +
      '&start[countryId]=' +
      firstLocation.country_id +
      '&dates=' +
      startDate +
      '&budget=moderate' +
      '&finish[id]=' +
      lastLocation.place_id +
      '&finish[name]=' +
      encodeURIComponent(lastLocation.name) +
      '&finish[days]=' +
      (!lastLocation.days_in_city ? 0 : lastLocation.days_in_city) +
      '&finish[countryId]=' +
      lastLocation.country_id +
      '&route=' +
      encodeURIComponent(tripRoute) +
      '&requestEngine=yes';

    return this.httpService.createTripAI(params).pipe(
      map((res: any) => {
        if (res) {
          let numDays = 0;
          routes.forEach((route, index) => {
            const destination = res.destinations[index];
            route.days_in_city = parseInt(route.days_in_city);
            destination.days_in_city = parseInt(route.days_in_city);

            if (
              index === routes.length - 1 &&
              route.place_id !== routes[0].place_id
            ) {
              route.days_in_city--;
              destination.days_in_city--;
            }
            numDays += route.days_in_city;
          });

          aiAssistant.routes = routes;
          aiAssistant.messages[aiAssistant.messages.length - 1].cities = routes;

          return res.destinations;
        }

        return null;
      }),
    );
  }
}
